// Only the latest request may write, so a slow older page cannot land over a newer one.
let latestEventsRequest = 0;

export const useEventsStore = defineStore('events', {
  state: () => {
    return {
      total: 0,
      currentPage: 1,
      perPage: 50,
      searchQuery: '',
      events: [],
    };
  },

  actions: {
    async fetchEvents({ filter, endDateLimit } = {}) {
      latestEventsRequest += 1;
      const request = latestEventsRequest;

      const response = await useApi.get('/events', {
        params: {
          filter,
          endDateLimit,
          page: this.currentPage,
          perPage: this.perPage,
          search: this.searchQuery || undefined,
        },
      }).catch((error) => {
        console.error(error);
        useToast.error(useT('bcd114'));
      });

      if (response && request === latestEventsRequest) {
        this.total = response.total;
        this.events = response.results;
      }
    },

    // Dialog-scoped fetch — returns events for a single workspace WITHOUT mutating
    // the main `events` state used by the events table.
    async fetchEventsByWorkspace(workspaceDomain, { includeIgnored = false } = {}) {
      const response = await useApi.get('/events', {
        params: { workspaceDomain, ...(includeIgnored && { includeIgnored: 'true' }) },
      }).catch((error) => {
        console.error(error);
        useToast.error(useT('bcd114'));
      });

      return response?.results || [];
    },

    async changePlan({ eventId, planId, workspaceDomain }) {
      const response = await useApi.post(`/events/${eventId}/change-plan`, {
        body: {
          planId,
          workspaceDomain,
        },
      }).catch((error) => {
        console.error(error);
        useToast.error(useT('bcd114'));
      });

      return response;
    },
  },

  getters: {
    getEvents(state) {
      return {
        total: state.total,
        results: state.events,
      };
    },
  },
});
